module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Electric/Gas-stove-9af133ade97b3822f804fbf1ffccab53.svg";